import ArrowTriangleheadSwapCircle from './ArrowTriangleheadSwapCircle';

export default ArrowTriangleheadSwapCircle;
